import React from "react";
import {FormikProps} from "formik";
import CheckboxField, {CheckboxFieldProps} from "./CheckboxField";
import {get} from "lodash";
import getCompleteFieldName from "./factory/helper";

export interface FormCheckboxFieldProps<T> extends Omit<CheckboxFieldProps, "name" | "checked" | "form" | "onChange"> {
    fieldName: keyof T;
    subFieldName?: string;
    form: FormikProps<T>;
    onChange?: (fieldName: keyof T, checked: boolean) => void;
}

export default function FormCheckboxField<T>({
    fieldName,
    subFieldName,
    form,
    onChange,
    ...rest
}: FormCheckboxFieldProps<T>) {
    const name = getCompleteFieldName(fieldName, subFieldName);
    const handleChange = (target: EventTarget, checked: boolean) => {
        if (onChange) {
            onChange(fieldName, checked);
        } else {
            form.setFieldValue(String(fieldName), checked);
        }
    };
    return <CheckboxField name={name} checked={get(form.values, name)} onChange={handleChange} {...rest} />;
}
